import { render, staticRenderFns } from "./zAgreement.vue?vue&type=template&id=28032e22&scoped=true"
import script from "./zAgreement.vue?vue&type=script&lang=js"
export * from "./zAgreement.vue?vue&type=script&lang=js"
import style0 from "./zAgreement.vue?vue&type=style&index=0&id=28032e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28032e22",
  null
  
)

export default component.exports